import {Component, Input} from '@angular/core';
import { LeftMenuItem } from '../../left-panel/live-map-panel.component';
import { NgClass, NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-left-menu-item',
  templateUrl: './left-menu-item.component.html',
  styleUrls: ['./left-menu-item.component.scss'],
  imports: [NgClass, NgStyle, MatIcon, MatMenuTrigger, MatIconButton, MatMenu, MatMenuItem],
})
export class LeftMenuItemComponent {
  @Input() input: LeftMenuItem;
  @Input() small = false;
}
